import * as utils from "@/mm/utils.js";

// 是否可以显示这个组件
export function formatWatch(data) {

  data.user_display = 2
  const pageId = parseInt(utils.getQueryParams({key: 'id'}))
  const pageType = parseInt(utils.getQueryParams({key: 'page_type'}))
  if (pageType === 1) {
    // 3 产品详情
    if (data.name === '产品简介' && pageId === 3) data.user_display = 1
    else if (data.name === '产品详情' && pageId === 3) data.user_display = 1
    else if (data.name === '产品Attribute' && pageId === 3) data.user_display = 1
    // 7 新闻详情
    else if (data.name === '新闻详情' && pageId === 7) data.user_display = 1
    // 5 案例详情
    else if (data.name === '案例详情' && pageId === 5) data.user_display = 1
    // 12 单页详情
    else if (data.name === '单页详情' && pageId === 12) data.user_display = 1
    // 2 产品列表、6新闻列表、4案例列表、8下载列表、10证书列表、11视频列表、9FAQ列表
    else if (
      data.name === '展开收起-文本' &&
      (pageId === 2 ||
        pageId === 6 ||
        pageId === 4 ||
        pageId === 8 ||
        pageId === 10 ||
        pageId === 11 ||
        pageId === 9)
    )
      data.user_display = 1
    else if (data.name === '展开收起-标签' && (pageId === 2 || pageId === 3)) data.user_display = 1
    else if (data.name === 'CTA') data.user_display = 1
    // 2 产品列表
    else if (data.name === '产品图文' && pageId === 2) data.user_display = 1
    // 2 产品分类列表
    else if (data.name === '产品分类简介' && pageId === 13) data.user_display = 1
  } else if (pageType === 3) {
    // 12 单页详情
    if (data.name === '单页详情') data.user_display = 1
  }

  // 递归设置user_display
  const setUserDisplay = (data) => {

    if (data.list) {
      data.list.forEach((item) => {
        item.user_display = 2
        setUserDisplay(item)
      })
    }

  }
  if (data.user_display === 2) {
    setUserDisplay(data)
  }
  return data
}

export function createOldMenu() {
  const list = [

    {
      name: '控件库',
      key: 'widgets',
      icon: 'icon-kongjian-',
      list: [
      ]
    },
    {
      name: '模板库',
      key: 'template',
      icon: 'icon-mobanku-',
      list: []
    },
    {
      name: '收藏',
      key: 'collect',
      icon: 'icon-shoucang',
      list: [
        {
          name: '收藏列表',
          list: []
        }
      ]
    }
  ]
  return list
}

export function getType(json, isModule){
  var res
  if(isModule){
    if (json.code_name) {
      res =  json.code_name
    }
  }else{
    if (json.code_name) {
      res =  json.code_name
    } else if (json.name) {
      res =  json.name
    }
  }


  return res
}

export function extraProperty(json, isModule){
  var res =  {
    ...json,
    _type: getType(json, isModule),
    user_display: (()=>{
      if (mm.store.state.authInfo.rule === 'admin'){
        return 1
      }else{
        return json.user_display
      }
    })()
  }

  return res
}
